var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPeak1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 33,
    viewBox: "0 0 40 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_327_2066)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.5671 2.17122C30.2734 -1.77734 30.7031 6.03516 36.3053 1.15885V9.11458C30.9603 13.9225 29.7949 6.15234 24.5671 10.0911V2.17122ZM40 32.0703H9.36198L17.7832 18.7598L23.1999 22.8451C23.3734 22.9756 23.5874 23.0406 23.8042 23.0287C24.021 23.0168 24.2266 22.9287 24.3848 22.7799L29.541 18.3691L40 32.0703ZM18.7663 17.2038L22.6725 11.0189V2.02799H22.7246C22.5197 1.90628 22.3604 1.7208 22.2709 1.49993C22.1814 1.27907 22.1667 1.03497 22.2291 0.804975C22.2915 0.574982 22.4275 0.371758 22.6164 0.226386C22.8052 0.0810141 23.0364 0.00149796 23.2747 0V0C23.5136 8.33388e-05 23.7458 0.0785859 23.9357 0.223448C24.1256 0.36831 24.2627 0.571517 24.326 0.801853C24.3892 1.03219 24.375 1.27691 24.2857 1.49842C24.1963 1.71994 24.0367 1.90599 23.8314 2.02799H23.8835V10.957L28.4277 16.9271L23.7174 20.9342L18.7663 17.2038ZM0 32.0703L9.57357 16.1198C9.64471 15.9954 9.74531 15.8903 9.86654 15.8138C10.0613 15.6928 10.2961 15.6539 10.5195 15.7058C10.7428 15.7577 10.9365 15.896 11.0579 16.0905C11.9368 17.4935 12.7962 18.7207 13.6621 19.8503L7.25586 30.4915C6.92622 30.9518 6.74971 31.5042 6.7513 32.0703H0Z",
    fill: "#50ACDE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_327_2066"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 32.0703,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeak1);
export default __webpack_public_path__ + "static/media/peak 1.da5420dc9b54d22445236c476a6469a6.svg";
export { ForwardRef as ReactComponent };